import type { LinkRowItem } from '../gql/types';

export const processLinkRowItem = (item: LinkRowItem): string | undefined => {
	const itemData = item.value[0].data;
	if (!itemData) {
		return undefined;
	} else if (itemData.__typename === 'ConfluencePage') {
		return Boolean(itemData.links?.base) && Boolean(itemData.links?.webUi)
			? `${itemData.links.base}${itemData.links.webUi}`
			: undefined;
	} else if (itemData.__typename === 'JiraIssue') {
		return itemData.webUrl;
	}
};
